require('angular').module('wowApp.common')
    .service('PerformanceMeasurerService', ['FeatureService', 'AtmService', require('./performance-measurer-service')])
    .directive('wowPerformanceEndMeasure', ['$timeout', 'PerformanceMeasurerService', require('./performance-end-measure-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/performance/index.js
 **/